import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BottomSheet from "Trackalyze/BottomSheet";
import Sort from "./Sort";

const SortWrapperPortrait = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(true);
  const [targetNode, setTargetNode] = useState(null);

  useEffect(() => {
    setTargetNode(document.getElementById("app"));
  }, []);

  const handleClose = () => setIsOpen(false);
  const handleAfterClose = () => navigate(-1);

  if (!targetNode) return null;

  return createPortal(
    <BottomSheet animate={isOpen} onAfterAnimate={handleAfterClose}>
      <Sort onClose={handleClose} portrait />
    </BottomSheet>,
    targetNode,
  );
};

export default SortWrapperPortrait;
